import Swiper from 'swiper';

const headerSliderContainer = document.querySelector('.js-header-gallery');

if (headerSliderContainer) {
  const headerSlider = new Swiper(headerSliderContainer, {

  });
}




/**
 * Fixed Header with headroom.js
 * @dependencies headroom.js
 */

import Headroom from 'headroom.js';

// Header Element
const headerEl = document.querySelector('.js-fixed-header');
console.log(headerEl, Headroom)

// Headroom Options
const fixedHeader = new Headroom(headerEl, {
  tolerance: 5,
  offset : 205,
  classes: {
    initial: "initialized",
    pinned: "is-pinned",
    unpinned: "is-unpinned"
  }
});

fixedHeader.init();
